import axios from "axios";
import config from "../config.json";

let { liveURL, localURL, dev } = config;

let API = dev ? localURL : liveURL;

export async function upload_image(data) {
  // console.log(data);
  return await axios.post(`${API}/get_URL`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export async function add_tag(data) {
  return await axios.post(`${API}/add-tag`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export async function create_blog(data) {
  return await axios.post(`${API}/create_blog`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export async function edit_blog(data) {
  data.is_active = data.is_active ? 1 : 0;
  return await axios.patch(`${API}/edit-blog`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export async function get_list(data) {
  let { page, limit, search } = data;
  return await axios.get(
    `${API}/get-list?page=${page}&limit=${limit}&search=${search || null}`
  );
}
export async function get_blog_details(data) {
  let { slug } = data;
  return await axios.get(`${API}/get-blog-details?slug=${slug}`);
}
export async function meta_details() {
  return await axios.get(`${API}/meta-details`);
}
export async function list_tag() {
  return await axios.get(`${API}/list-tag`);
}
export async function add_author(data) {
  return await axios.post(`${API}/addAuthor`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export async function edit_author(data) {
  return await axios.patch(`${API}/editAuthor`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export async function list_author({ page, limit }) {
  return await axios.get(
    `${API}/listAuthor?page=${page}&limit=${limit || 5}`
  );
}
export async function get_author_by_id({ id }) {
  return await axios.get(`${API}/getAuthorById?id=${id}`);
}
// user track

// parameter: 5,
// page: page,
// perPage: localState.perPage,
// email : localState.email,
// to : localState.to,
// from : localState.from,
// filter : localState.filtered
export const listTrackRecords = async (data) => {
  return await axios.post(`${API}/listTrackRecords`, data);
};
export const metaCount = async () => {
  return await axios.get(`${API}/metaCount`);
};

// reviews

export const metaReview = async () => {
  return await axios.get(`${API}/review/metaReview`);
};

export const listReview = async ({limit, page, listAll = true}) => {
  return await axios.get(`${API}/review/listReview?listAll=${listAll}&page=${page}&limit=${limit}`);
};

export const adminApprovalReview = async (data) => {
  return await axios.post(`${API}/review/adminApproval`,data);
};
